define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UnicodeUtility = /** @class */ (function () {
        function UnicodeUtility() {
        }
        /**
         * convert ASCII to wildcard
         */
        UnicodeUtility.addAccents = function (input) {
            var retval = input;
            retval = retval.replace(/([ao])e/ig, '$1');
            retval = retval.replace(/ss/ig, 's');
            retval = retval.replace(/e/ig, '[eèéêë]');
            retval = retval.replace(/c/ig, '[cç]');
            retval = retval.replace(/i/ig, '[iîï]');
            retval = retval.replace(/u/ig, '[uùûü]');
            retval = retval.replace(/y/ig, '[yÿ]');
            retval = retval.replace(/s/ig, '(ss|[sßș])');
            retval = retval.replace(/t/ig, '([tţț])');
            retval = retval.replace(/a/ig, '([aàâäă]|ae)');
            retval = retval.replace(/o/ig, '([oôö]|oe)');
            return retval;
        };
        /**
         * escape UNICODE characters in string
         */
        UnicodeUtility.escapeUnicode = function (str) {
            // tslint:disable:no-bitwise
            // convertCharStr2jEsc
            // Converts a string of characters to JavaScript escapes
            // str: sequence of Unicode characters
            var highsurrogate = 0;
            var suppCP;
            var pad;
            var outputString = '';
            for (var i = 0; i < str.length; i++) {
                var cc = str.charCodeAt(i);
                if (cc < 0 || cc > 0xFFFF) {
                    outputString += '!Error in convertCharStr2UTF16: unexpected charCodeAt result, cc=' + cc + '!';
                }
                if (highsurrogate !== 0) { // this is a supp char, and cc contains the low surrogate
                    if (0xDC00 <= cc && cc <= 0xDFFF) {
                        suppCP = 0x10000 + ((highsurrogate - 0xD800) << 10) + (cc - 0xDC00);
                        suppCP -= 0x10000;
                        outputString += '\\u'
                            + this.dec2hex4(0xD800 | (suppCP >> 10)) + '\\u' + this.dec2hex4(0xDC00 | (suppCP & 0x3FF));
                        highsurrogate = 0;
                        continue;
                    }
                    else {
                        outputString += 'Error in convertCharStr2UTF16: low surrogate expected, cc=' + cc + '!';
                        highsurrogate = 0;
                    }
                }
                if (0xD800 <= cc && cc <= 0xDBFF) { // start of supplementary character
                    highsurrogate = cc;
                }
                else { // this is a BMP character
                    switch (cc) {
                        case 0:
                            outputString += '\\0';
                            break;
                        case 8:
                            outputString += '\\b';
                            break;
                        case 9:
                            outputString += '\\t';
                            break;
                        case 10:
                            outputString += '\\n';
                            break;
                        case 13:
                            outputString += '\\r';
                            break;
                        case 11:
                            outputString += '\\v';
                            break;
                        case 12:
                            outputString += '\\f';
                            break;
                        case 34:
                            outputString += '\\\"';
                            break;
                        case 92:
                            outputString += '\\\\';
                            break;
                        default:
                            if (cc > 0x1f && cc < 0x7F) {
                                outputString += String.fromCharCode(cc);
                            }
                            else {
                                pad = cc.toString(16).toUpperCase();
                                while (pad.length < 4) {
                                    pad = '0' + pad;
                                }
                                outputString += '\\u' + pad;
                            }
                    }
                }
            }
            // tslint:enable:no-bitwise
            return outputString;
        };
        /**
         * convert escaped UNICODE to ASCII
         */
        UnicodeUtility.removeUnicode = function (input) {
            var retval = input;
            retval = retval.replace(/\\u(00E[024]|010[23]|00C2)/ig, 'a');
            retval = retval.replace(/\\u00E7/ig, 'c');
            retval = retval.replace(/\\u00E[89AB]/ig, 'e');
            retval = retval.replace(/\\u(00E[EF]|00CE)/ig, 'i');
            retval = retval.replace(/\\u00F[46]/ig, 'o');
            retval = retval.replace(/\\u00F[9BC]/ig, 'u');
            retval = retval.replace(/\\u00FF/ig, 'y');
            retval = retval.replace(/\\u(00DF|021[89])/ig, 's');
            retval = retval.replace(/\\u(0163i|021[AB])/ig, 't');
            return retval;
        };
        /**
         * added by Yanosh Kunsh to include utf-8 string comparison
         */
        UnicodeUtility.dec2hex4 = function (textString) {
            // tslint:disable:no-bitwise
            var hexequiv = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
            return hexequiv[(textString >> 12) & 0xF]
                + hexequiv[(textString >> 8) & 0xF] + hexequiv[(textString >> 4) & 0xF]
                + hexequiv[textString & 0xF];
            // tslint:enable:no-bitwise
        };
        return UnicodeUtility;
    }());
    exports.default = UnicodeUtility;
});
